const DEFAULT_PROPERTIES_DATA = { loaded: false, properties: [] };

const getFlags = (state, key) => state.document.documentProperties[key];
const getDocumentPropertiesState = (state, key) => state.entities.documentProperties[key];

export const getDocumentProperties = (state, key) => {
  const flags = getFlags(state, key);

  if (!flags || !flags.loaded) return DEFAULT_PROPERTIES_DATA;

  const documentPropertiesData = getDocumentPropertiesState(state, key);
  return {
    properties: documentPropertiesData,
    ...flags
  };
};
